// extracted by css-extract-rspack-plugin
export default {"form":"PQq0iX","centerState":"oJrYsI","errorIcon":"ZhFqbr","body":"nz8C8X","columns":"N8C8SQ","column":"tvfoIu","formButtons":"S21qTY"};